export var SocketEventEnum;
(function (SocketEventEnum) {
    SocketEventEnum["JOIN"] = "JOIN";
    SocketEventEnum["LEAVE"] = "LEAVE";
    SocketEventEnum["UPDATE_TOKEN"] = "UPDATE_TOKEN";
    SocketEventEnum["REQUEST_TOKEN_UPDATE"] = "REQUEST_TOKEN_UPDATE";
    SocketEventEnum["REJECT"] = "REJECT";
})(SocketEventEnum || (SocketEventEnum = {}));
//# sourceMappingURL=call-event.enum.js.map